import { Link as ChakraLink, useStyles } from "@chakra-ui/react";

interface Props {
  node: unknown;
}

/**
 * Links that are part of Markdown are (for now) all external
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Link = ({ node, ...props }: Props) => {
  const styles = useStyles();

  return <ChakraLink sx={styles.link} isExternal {...props} />;
};

export default Link;
